import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_bwaise-voices/artifacts/1a5a97ee_IMG_9775.jpeg";

const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/gallery", label: "Gallery" },
  { path: "/collection/rehearsals", label: "Rehearsals" },
  { path: "/collection/community", label: "Community" },
  { path: "/events", label: "Events" },
  { path: "/contact", label: "Contact" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 glass" data-testid="main-header">
      <div className="section-container">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img src={LOGO_URL} alt="Good Samaritans' Choir Bwaise" className="h-10 md:h-14 w-10 md:w-14 rounded-full object-cover" />
            <div className="hidden sm:block">
              <p className="font-bold text-[#1A1A1A] text-sm md:text-base leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Good Samaritans'
              </p>
              <p className="text-[#C4392D] text-xs md:text-sm font-medium" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Choir Bwaise
              </p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1" data-testid="desktop-nav">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "bg-[#FFF3E6] text-[#C4392D]"
                    : "text-[#4A4A4A] hover:text-[#1A1A1A] hover:bg-gray-100"
                }`}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link to="/donate" data-testid="nav-donate-btn">
              <Button className="btn-primary text-sm hidden sm:inline-flex">
                Donate
              </Button>
            </Link>
            <button
              className="md:hidden p-2.5 rounded-xl hover:bg-gray-100 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
              onClick={() => setMobileOpen(!mobileOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-gray-100 pt-3 animate-in slide-in-from-top-2 duration-200" data-testid="mobile-nav">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3.5 rounded-xl text-base font-medium transition-colors ${
                  location.pathname === link.path
                    ? "bg-[#FFF3E6] text-[#C4392D]"
                    : "text-[#4A4A4A] hover:text-[#1A1A1A] hover:bg-gray-50"
                }`}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/donate"
              onClick={() => setMobileOpen(false)}
              className="block mt-3 px-4"
              data-testid="mobile-nav-donate"
            >
              <Button className="btn-primary w-full text-base py-3">Donate</Button>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}
